import { useContext } from 'react';
import { ReturnDetailsContext } from '../../contexts';

export function useReturnDetails() {
  const context = useContext(ReturnDetailsContext);

  return context;
}
